module.exports = __webpack_public_path__ + "img/banner-16.494b2830.jpg";